import { render, staticRenderFns } from "./loginModalV2.vue?vue&type=template&id=05acd4e6&scoped=true"
import script from "./loginModalV2.vue?vue&type=script&lang=js"
export * from "./loginModalV2.vue?vue&type=script&lang=js"
import style0 from "./loginModalV2.vue?vue&type=style&index=0&id=05acd4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05acd4e6",
  null
  
)

export default component.exports